module.exports = __webpack_public_path__ + "media/images/sp/special_reports/icon_sakura-aa3a73f096189700e266b47bb8c6ea46.png";